module.exports = __webpack_public_path__ + "media/animation2-c.7af16289.mp4";